import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
} from '@angular/core';
import { dispatch, select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { SIGN_IT_DESCRIPTION } from '.';
import {
	BusinessState,
	BusinessActions,
	BusinessFeatureFlagSelectors,
} from '@state/business';
import { SIGN_IT_COST_IN_CENTS } from '@models/e-signing';
import { doCentsToDollars } from 'src/app/shared/core/util/money/money';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { TestHooks } from './sign-it.hooks';
import { SignItConnectionFlowService } from 'src/app/shared/services/signit-connection-flow/signit-connection-flow.service';

@Component({
	selector: 'app-sign-it',
	templateUrl: './sign-it.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class SignItComponent implements AfterViewInit {
	testHooks = TestHooks;
	private signItConnectService = inject(SignItConnectionFlowService);

	isLoggedInUserAdmin_ = select(BusinessUsersState.isLoggedInUserAdmin);
	isSignItConnected_ = select(BusinessState.isSignITSelected);
	isSignItFeatureFlagConnected_ = select(
		BusinessFeatureFlagSelectors.sc16163EnableSignIt,
	);

	OverwriteBusinessFields = dispatch(BusinessActions.OverwriteBusinessFields);

	integrationCost = doCentsToDollars(SIGN_IT_COST_IN_CENTS);
	SIGN_IT_DESCRIPTION = SIGN_IT_DESCRIPTION;
	businessUrl = UrlService.Manage_Finances_General();

	benefits = [
		'Streamline e-signing with pre-tagged signature fields and auto-filled recipient emails from matter data.',
		'Track signing status for all parties in real time, directly within Closer.',
		'Sync e-signing expenses to your Statement of Account or Trust Ledger for seamless client disbursement.',
		'Store signed documents automatically in your matter for easy reuse in final reports and other packages.',
	];

	tooltips_ = computed(() =>
		this.isLoggedInUserAdmin_() ? null : 'Only Admins can disconnect.',
	);

	ngAfterViewInit(): void {
		if (this.isSignItConnected_()) return;

		setTimeout(() => {
			this.openEducationalModal();
		}, 0);
	}

	openEducationalModal(): void {
		if (this.isSignItFeatureFlagConnected_()) {
			this.signItConnectService.openEducationalModal();
		}
	}

	disconnectSignIt(): void {
		this.signItConnectService.disconnectFromSignIt();
	}
}
